import {
  LeaderboardBronze,
  LeaderboardGold,
  LeaderboardSilver,
} from "../../icons";
import { leaderboardRow } from "./LeaderboardTable";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/routes";

export const LEADERBOARD_POSITION = ["gold", "silver", "bronze"];

const imageClass: { [key: string]: string } = {
  gold: "border-gold w-24 h-24",
  silver: "border-silver w-20 h-20",
  bronze: "border-bronze w-20 h-20",
};

const gradientClass: { [key: string]: string } = {
  gold: "h-32 w-24 bg-leaderboard-gold",
  silver: "h-28 w-20 bg-leaderboard-silver",
  bronze: "h-28 w-20 bg-leaderboard-bronze",
};

const ImageWithGradient = ({
  userDetails,
  position,
}: {
  position: string;
  userDetails: leaderboardRow;
}) => {
  return (
    <div
      className={`relative ${position === "gold" ? "w-24 h-48" : "w-20 h-40"}`}
    >
      <Link
        to={ROUTES.USER_PROFILE.replace(":user_id", userDetails.user_id?._id)}
      >
        <img
          className={`rounded-full object-cover shadow border-4 absolute top-0 left-0 z-10 ${imageClass[position]}`}
          src={userDetails.user_id?.profile_picture}
          alt=""
        />
      </Link>
      <div
        className={`absolute z-0 ${position === "gold" ? "top-11" : "top-10"} ${
          gradientClass[position]
        }`}
      ></div>
      <div className="absolute z-10 bottom-0 flex flex-col justify-center items-center w-full">
        {position === LEADERBOARD_POSITION[0] && <LeaderboardGold />}
        {position === LEADERBOARD_POSITION[1] && <LeaderboardSilver />}
        {position === LEADERBOARD_POSITION[2] && <LeaderboardBronze />}
        <Link
          to={ROUTES.USER_PROFILE.replace(":user_id", userDetails.user_id?._id)}
          className="hover:underline"
        >
          <p className="text-white text-center text-xs leading-4 w-20 truncate px-2">
            {userDetails.user_id?.first_name}
          </p>
        </Link>
        <p className="text-[#bdbdbd] text-center text-[10px] font-normal w-20 truncate px-2">
          {userDetails.user_id?.company_name}
        </p>
      </div>
    </div>
  );
};

const LeaderboardTile = ({
  topUsers,
  type,
}: {
  topUsers: leaderboardRow[];
  type: string;
}) => {
  return (
    <>
      <div
        style={{
          boxShadow:
            "0px 2rem 0 -0.5rem rgba(38, 38, 38, 0.4), 0px 1rem 0 -0.2rem rgba(38, 38, 38, 0.6)",
        }}
        className="flex items-end justify-center bg-neutral-800 rounded-2xl h-72 w-full md:w-80 px-4 pb-7 gap-3"
      >
        {topUsers.map((userDetails, index) => (
          <div
            key={index}
            className={`flex flex-col items-center ${
              index === 1 ? "order-first" : ""
            }`}
          >
            <p className="text-white text-xl font-bold leading-relaxed">
              {type === "weekly"
                ? userDetails?.weekly_gain
                : type === "daily"
                  ? userDetails?.daily_gain
                  : userDetails.balance}
            </p>
            <div className="flex gap-1 mb-2">
              <img
                src="/assets/icons/star-red.png"
                className="w-3 h-3"
                alt="xp-star"
              />
              <p className="text-white text-[10.05px] leading-[13.39px]">XP</p>
            </div>
            <ImageWithGradient
              userDetails={userDetails}
              position={LEADERBOARD_POSITION[index]}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default LeaderboardTile;
